import { h, defineComponent } from 'vue';
import { box, container, pageSubtitle } from '@/ui/components';
import { Icon } from '@/ui/components/icon/Icon';
import { t } from '@/ui/i18n/i18n';
import { operatingSystemToStoreBadge } from '@/ui/helpers';
import { appStoreBadge, googlePlayStoreBadge } from '@/ui/components/onboarding/StoreImageLink';
// @ts-ignore
import is from 'is_js';

export const UpdateApp = defineComponent({
  name: 'UpdateApp',
  setup() {
    const updateRequired = h('div', { class: 'welcome-page__title' }, [
      pageSubtitle(t('update-app.title')),
      h('div', t('update-app.subtitle')),
    ]);

    const isSupportedMobileOperatingSystem = is.ios() || is.android();

    const propsBadge = { classes: 'welcome-page__store-badges' };

    const downloadStoreBadge = isSupportedMobileOperatingSystem
      ? operatingSystemToStoreBadge(propsBadge)
      : [
        appStoreBadge(propsBadge),
        googlePlayStoreBadge(propsBadge),
      ];

    return function render() {
      return h('div', { class: 'welcome-page' }, [
        container([
          box([
            h(Icon, {
              props: {
                icon: 'check-circle',
                classes: 'check-circle-icon',
                iconPack: 'fal',
              },
            }),
            updateRequired,
            downloadStoreBadge,
          ]),
        ], 'small', 'px-8 pb-8'),
      ]);
    };
  },
});
